import { type Clip } from '@air/api/types';

/**
 * Returns the display name for a clip, ensuring the file extension is included.
 * Prefers user-set title over importedName (the original filename from the source platform).
 */
export const getClipDisplayName = (clip: Pick<Clip, 'title' | 'importedName' | 'ext'>): string => {
  const baseName = clip.title ?? clip.importedName ?? 'Untitled';

  if (!clip.ext) {
    return baseName;
  }

  const extWithDot = `.${clip.ext}`;

  if (baseName.toLowerCase().endsWith(extWithDot.toLowerCase())) {
    return baseName;
  }

  return `${baseName}${extWithDot}`;
};
